const openModals = document.querySelectorAll("[data-open]");
const closeModals = document.querySelectorAll("[data-close]");
const isVisible = "is-visible";
let viewportWidth;

// Set/update the viewportWidth value
let setViewportWidth = function () {
	viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};

const openModal = function () {
	// only use the modal if on tablet or higher
	for (const el of openModals) {
		el.addEventListener("click", function () {
			if (viewportWidth >= 768) {
				const modalId = this.dataset.open;
				document.getElementById(modalId).classList.add(isVisible);
				document.body.setAttribute("style", "overflow:hidden;");
				document.getElementById("global-header").setAttribute("style", "display:none;");
				document.getElementById("top-bar").setAttribute("style", "display:none;");
				document.getElementsByTagName("main")[0].setAttribute("style", "z-index:9997;");
			}
		});
	}
};

window.addEventListener("load", function () {
	setViewportWidth();
	openModal();

	window.addEventListener(
		"resize",
		function () {
			setViewportWidth();
			openModal();
		},
		false,
	);
});

for (const el of closeModals) {
	el.addEventListener("click", function () {
		document.querySelector(".modal.is-visible").classList.remove(isVisible);
		document.body.removeAttribute("style", "overflow:hidden;");
		document.getElementById("global-header").removeAttribute("style", "display:none;");
		document.getElementById("top-bar").removeAttribute("style", "display:none;");
		document.getElementsByTagName("main")[0].removeAttribute("style", "z-index:9997;");
	});
}

document.addEventListener("click", (e) => {
	if (e.target == document.querySelector(".modal.is-visible")) {
		document.querySelector(".modal.is-visible").classList.remove(isVisible);
		document.body.removeAttribute("style", "overflow:hidden;");
		document.getElementById("global-header").removeAttribute("style", "display:none;");
		document.getElementById("top-bar").removeAttribute("style", "display:none;");
		document.getElementsByTagName("main")[0].removeAttribute("style", "z-index:9997;");
	}
});

document.addEventListener("keyup", (e) => {
	// if we press the ESC
	if (e.key == "Escape" && document.querySelector(".modal.is-visible")) {
		document.querySelector(".modal.is-visible").classList.remove(isVisible);
		document.body.removeAttribute("style", "overflow:hidden;");
		document.getElementById("global-header").removeAttribute("style", "display:none;");
		document.getElementById("top-bar").removeAttribute("style", "display:none;");
		document.getElementsByTagName("main")[0].removeAttribute("style", "z-index:9997;");
	}
});
